import React, {Component} from 'react';
import LoadingSpinner from "../Utils/LoadingSpinner";


class AgreementTransactions extends Component {
    state = {
        loading: true
    };

    componentDidMount() {
        // Get the list of agreements first
        this.props.simGps.getPartnerTransactions(this.props.agreement_id,
            (success, result) => {
                if(success){
                    this.setState({loading:false, transactions: result})
                }else{
                    this.setState({loading:false})
                }
            }
        );
    }

    render() {
        if (this.state.loading) {
            return (<LoadingSpinner text="Retrieving transactions ..."/>);
        } else {
            return (
                this.state.transactions.map( transaction => (
                    <div>
                        {JSON.stringify(transaction)}
                    </div>
                ) )
            );
        }
    }
}


class PartnerTransactions extends Component {
    state = {
        loading: true
    };

    componentDidMount() {
        // Get the list of agreements first
        this.props.simGps.getPartnerAgreements(
            (success, result) => {
                if(success){
                    this.setState({loading:false, agreements: result})
                }else{
                    this.setState({loading:false})
                }
            }
        );
    }

    render() {
        if (this.state.loading) {
            return (<LoadingSpinner text="Retrieving agreements ..."/>);
        } else {
            return (
                this.state.agreements.map( agreement => (
                    <div key={agreement.id}>
                        Name {agreement.name}
                        My share {agreement.percent/ 100.} %
                        <AgreementTransactions  {...this.props} agreement_id={agreement.id}/>
                    </div>

                ) )
            );
        }
    }
}

export default PartnerTransactions;
